import React, { useState } from "react";
import axios from "../api/axios";

export default function EmailModal({ onClose, preset }) {
  const [to, setTo] = useState(preset?.to || "");
  const [subject, setSubject] = useState(preset?.subject || "");

  // Convertimos <br> → \n para que se vea en el textarea
  const initialBody =
    preset?.body?.replace(/<br\s*\/?>/gi, "\n") || "";

  const [body, setBody] = useState(initialBody);
  const [attachments, setAttachments] = useState([]);
  const [sending, setSending] = useState(false);

  function handleFileChange(e) {
    setAttachments([...e.target.files]);
  }

  async function handleSend() {
    if (!to.trim()) return alert("Debe indicar un destinatario.");

    try {
      setSending(true);

      const formData = new FormData();
      formData.append("to", to);
      formData.append("subject", subject);

      // Convertimos saltos de línea → HTML
      const htmlBody = body.replace(/\n/g, "<br>");
      formData.append("html", htmlBody);

      attachments.forEach((file) => {
        formData.append("attachments", file);
      });

      // RUTA CORRECTA
      await axios.post("/mail/send", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      alert("Correo enviado correctamente.");
      onClose();
    } catch (err) {
      console.error("Error enviando correo:", err);
      alert("Error al enviar el correo.");
    } finally {
      setSending(false);
    }
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        backdropFilter: "blur(5px)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          width: "95%",
          maxWidth: "1100px",
          height: "90vh",
          background: "rgba(15,23,42,0.95)",
          borderRadius: 16,
          padding: 24,
          display: "flex",
          flexDirection: "column",
          border: "1px solid rgba(255,255,255,0.15)",
        }}
      >

        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 16,
            borderBottom: "1px solid rgba(255,255,255,0.12)",
            paddingBottom: 10,
          }}
        >
          <h2 style={{ margin: 0 }}>Enviar correo</h2>

          <button
            onClick={onClose}
            style={{
              background: "transparent",
              color: "white",
              border: "none",
              fontSize: 20,
              cursor: "pointer",
            }}
          >
            ✖
          </button>
        </div>

        {/* FORMULARIO */}
        <div style={{ overflowY: "auto", paddingRight: 10 }}>

          {/* PARA */}
          <label style={{ display: "block", marginBottom: 8 }}>
            Para:
          </label>
          <input
            value={to}
            onChange={(e) => setTo(e.target.value)}
            style={{
              width: "100%",
              padding: 10,
              marginBottom: 16,
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(255,255,255,0.07)",
              color: "white",
            }}
          />

          {/* ASUNTO */}
          <label style={{ display: "block", marginBottom: 8 }}>
            Asunto:
          </label>
          <input
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={{
              width: "100%",
              padding: 10,
              marginBottom: 16,
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(255,255,255,0.07)",
              color: "white",
            }}
          />

          {/* CUERPO */}
          <label style={{ display: "block", marginBottom: 8 }}>
            Mensaje:
          </label>
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            style={{
              width: "100%",
              height: "300px",
              padding: 10,
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(255,255,255,0.07)",
              color: "white",
              resize: "vertical",
            }}
          ></textarea>

          {/* ADJUNTAR */}
          <label style={{ display: "block", margin: "16px 0 8px" }}>
            Adjuntar archivos:
          </label>
          <input
            type="file"
            multiple
            onChange={handleFileChange}
            style={{ marginBottom: 20 }}
          />

          {attachments.length > 0 && (
            <div style={{ marginBottom: 20 }}>
              <strong>Archivos seleccionados:</strong>
              <ul>
                {attachments.map((a, i) => (
                  <li key={i}>{a.name}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            borderTop: "1px solid rgba(255,255,255,0.12)",
            paddingTop: 12,
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "rgba(255,255,255,0.1)",
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.2)",
              color: "white",
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>

          <button
            disabled={sending}
            onClick={handleSend}
            style={{
              padding: "8px 20px",
              background: "rgba(59,130,246,0.6)",
              borderRadius: 8,
              border: "1px solid rgba(59,130,246,0.8)",
              color: "white",
              cursor: "pointer",
            }}
          >
            {sending ? "Enviando..." : "Enviar"}
          </button>
        </div>
      </div>
    </div>
  );
}
